<template>
    <div class="screen black" v-if="spiel">
        <!--<img width="740" src="../../../../assets/stream.jpg" style="position: absolute; top: 0; left: 0">
        <img width="740" src="../../../../assets/stream.jpg" style="position: absolute; top: 0; right: 0">
        <img width="740" src="../../../../assets/stream.jpg" style="position: absolute; bottom: 0; left: 0">
        <img width="740" src="../../../../assets/stream.jpg" style="position: absolute; bottom: 0; right: 0">-->
        <div :class="[{'ergebnis': streamType==='detail4'},
                      {'ergebnisUnten': streamType==='detail1or2'},
                      'text-center white--text']">
            <div :class="[{'paarung': streamType==='detail4'},
                      {'paarungUnten': streamType==='detail1or2'},
                      'black']">
                <div v-if="streamType==='detail4'" class="teams font-weight-medium">
                    <div>{{spiel.heim.teamName}}</div>
                    <div style="font-size: 28px" class="grey--text">vs.</div>
                    <div>{{spiel.gast.teamName}}</div>
                </div>
                <table class="text-center mx-auto mt-8">
                    <tr class="grey--text">
                        <td class="font-weight-medium px-4">Diff</td>
                        <td class="borderLeft borderRight font-weight-medium px-4" colspan="3">Spielstand</td>
                        <td class="font-weight-medium px-4">Diff</td>
                    </tr>
                    <tr>
                        <td class="px-4">{{spiel.heim.result.kegel-spiel.gast.result.kegel}}</td>
                        <td v-if="!isCup" class="borderLeft pl-4 font-weight-bold total">{{spiel.heim.result.mp}}</td>
                        <td v-else class="borderLeft pl-4 font-weight-bold">{{spiel.heim.result.kegel}}</td>
                        <td class="px-3 font-weight-bold">:</td>
                        <td v-if="!isCup" class="borderRight pr-4 font-weight-bold total">{{spiel.gast.result.mp}}</td>
                        <td v-else class="borderRight pr-4 font-weight-bold text-left">{{spiel.gast.result.kegel}}</td>
                        <td class="px-4">{{spiel.gast.result.kegel-spiel.heim.result.kegel}}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div v-if="streamType==='detail1or2'"
             class="teamsSmall font-weight-medium white--text">
            <v-row no-gutters>
                <v-col class="pl-4">
                    <span>{{spiel.heim.teamName}}</span>
                </v-col>
                <v-col class="text-right pr-4">
                    <span>{{spiel.gast.teamName}}</span>
                </v-col>
            </v-row>
        </div>
        <div :class="[{'durchgangMitte': streamType==='detail4'},
                      {'durchgangUnten': streamType==='detail1or2'},
                      'links']">
            <stream-details-bahn :partie="this.spiel.partien[leftPartie]" :is-cup="isCup"/>
        </div>
        <div :class="[{'durchgangMitte': streamType==='detail4'},
                      {'durchgangUnten': streamType==='detail1or2'},
                      'rechts']">
            <stream-details-bahn :partie="this.spiel.partien[rightPartie]" :is-cup="isCup"/>
        </div>
    </div>
</template>

<script>
    import { db } from '../../../../services/db'
    import {Spiel} from "../../../../services/data/spiel";
    import StreamDetailsBahn from "./streamDetailsBahn";
    export default {
        components: {
            StreamDetailsBahn,},
        name: "stream-details",
        data: () => ({
            spiel: null,
            spielRaw: null,
            landesverband: null,
            leftPartie: null,
            rightPartie: null,
            partieA: null,
            partieB: null,
            currentPartieSet: 1,
        }),
        computed: {
            isCup(){ return this.spiel.saison.isCup},
            streamType(){ return this.$route.query.type; },
        },
        created(){
            this.setSpielRaw();
            //window.print();
        },
        mounted () {
            document.body.classList.add('hideScrollbar')
        },
        destroyed () {
            document.body.classList.remove('hideScrollbar')
        },
        methods: {
            setSpielRaw(){
                db.collection("spiele").doc(this.$route.query.id)
                    .onSnapshot((doc) => {
                        this.spielRaw = doc.data();
                        this.spielRaw.id = doc.id;
                    });
            },
            setSpiel(to){
                this.spiel = new Spiel();
                this.spiel.stream = {};
                this.spiel.setFromDataObject(this.spielRaw);
                if ( this.spielRaw.stream ) { this.spiel.stream = this.spielRaw.stream }
                this.setPartien(to, null);
            },
            updateSpiel(to, from) {
                this.spiel.heim.result = this.spielRaw.heim.result;
                this.spiel.gast.result = this.spielRaw.gast.result;
                this.spiel.partien = this.spielRaw.partien;
                if ( this.spielRaw.stream ) { this.spiel.stream = this.spielRaw.stream }
                this.setPartien(to, from);
            },
            setPartien(to, from){
            // set manually!!!
                if ( this.spiel.stream && !this.spiel.stream.auto && this.spiel.stream.auto!==undefined ) {
                    this.setManually();
                    return;
                }
                let totalPartien = Object.keys(this.spiel.partien).length;
            // check for Partieswitch
                if ( (!this.partieA && !this.partieB) || !from ||
                    (!from.stream.auto && to.stream.auto) ) {
                    this.switchPartien(1);
                    this.setInitAfterCreate(to, totalPartien)
                } else {
                    let switched = this.checkForPartieWechsel(to, from, totalPartien);
                // check for Seitenwechsel
                    if ( !switched ) {
                        this.checkForSeitenwechsel(to, from, totalPartien)
                    }
                }
            },
                setInitAfterCreate(to, totalPartien){
                    for ( let i = 1; i <= totalPartien; i = i+2 ) {
                        const toStatus = to.partien[i].gast.input.d4 > 0 &&
                            to.partien[i].heim.input.d4 > 0 &&
                            to.partien[i+1].gast.input.d4 > 0 &&
                            to.partien[i+1].heim.input.d4 > 0;
                        console.log ("toStatus", toStatus);
                        if ( toStatus && i < totalPartien-1 ) {
                            this.switchPartien(i+2);
                        } else {
                            const toStatus = to.partien[i].gast.input.d2 > 0 &&
                                to.partien[i].heim.input.d2 > 0 &&
                                to.partien[i+1].gast.input.d2 > 0 &&
                                to.partien[i+1].heim.input.d2 > 0;
                            if ( toStatus ) { this.switchSide() }
                        }
                    }
                },
                checkForPartieWechsel(to, from, totalPartien){
                    for ( let i = 1; i <= totalPartien; i = i+2 ) {
                        const fromStatus = from.partien[i].gast.input.d4 > 0 &&
                            from.partien[i].heim.input.d4 > 0 &&
                            from.partien[i+1].gast.input.d4 > 0 &&
                            from.partien[i+1].heim.input.d4 > 0;
                        const toStatus = to.partien[i].gast.input.d4 > 0 &&
                            to.partien[i].heim.input.d4 > 0 &&
                            to.partien[i+1].gast.input.d4 > 0 &&
                            to.partien[i+1].heim.input.d4 > 0;
                        if ( !fromStatus && toStatus && i < totalPartien-1 ) {
                            setTimeout(()=>{this.switchPartien(i+2);},10000);
                            return true;
                        }
                    }
                    return false;
                },
                checkForSeitenwechsel(to, from, totalPartien){
                    for ( let i = 1; i <= totalPartien; i = i+2 ) {
                        const fromStatus = from.partien[i].gast.input.d2 > 0 &&
                            from.partien[i].heim.input.d2 > 0 &&
                            from.partien[i+1].gast.input.d2 > 0 &&
                            from.partien[i+1].heim.input.d2 > 0;
                        const toStatus = to.partien[i].gast.input.d2 > 0 &&
                            to.partien[i].heim.input.d2 > 0 &&
                            to.partien[i+1].gast.input.d2 > 0 &&
                            to.partien[i+1].heim.input.d2 > 0;
                        if ( !fromStatus && toStatus ) {
                            setTimeout(()=>{this.switchSide();},10000);
                            return;
                        }
                    }
                },
            switchPartien(i){
                this.partieA = i;
                this.partieB = i+1;
                this.leftPartie = this.partieA;
                this.rightPartie = this.partieB;
            },
            switchSide(){
                this.leftPartie = this.partieB;
                this.rightPartie = this.partieA;
            },
            setManually(){
                const startDg = this.spiel.stream.dg + (this.spiel.stream.dg - 1);
                this.switchPartien(startDg);
                if ( this.spiel.stream.switch ) { this.switchSide(); }
            }
        },
        watch: {
            spielRaw: {
                handler(to, from){
                    if ( to && !from ) {
                        this.setSpiel(to);
                    } else if ( to ) {
                        this.updateSpiel(to, from);
                    }
                },
                deep: true
            },
        }
    }
</script>

<style scoped>
    .ergebnis { position: absolute; width: 440px;
        left: 50%; transform: translateX(-50%);

    }
    .ergebnisUnten { position: absolute; width: 440px;
        left: 50%; transform: translateX(-50%);
        bottom: 32px;
    }
    .screen { width: 1920px; height: 1080px; position: fixed;
             top: 0; left: 0; }
    .durchgangMitte{
        width: 740px;
        height: 178px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    .durchgangUnten{
        width: 740px;
        height: 178px;
        position: absolute;
        bottom: 8px;
    }
    .rechts{
        right: 0;
    }
    .paarung { font-size: 36px; position: absolute; top: 0; padding-top: 40px; width: 100% }
    .paarungUnten { font-size: 36px; position: absolute; bottom: 0; padding-top: 40px; width: 100% }
    .teams { font-size: 42px }
    .teamsSmall { font-size: 42px; position: absolute; bottom: 186px; width: 100%}
    table {background-color: #252525; border-collapse: collapse}
    .resultHeader { font-size: 24px }
    .borderLeft {border-left: solid 4px black}
    .borderRight {border-right: solid 4px black}
    .total { font-size:  48px}

</style>